<script setup lang="ts"></script>
<template>
	<div>kekw</div>
</template>
<style scoped lang="scss"></style>
